// import React from 'react'
// import KycInProgress from "admin/common/icons/kycInProgress";
// import KycRejected from "admin/common/icons/kycRejected";
// import KycExpired from "admin/common/icons/kycExpired";
// import KycApproved from "admin/common/icons/kycApproved";
// import KycCompleted from "admin/common/icons/kycCompleted";
// import { useTranslation } from 'react-i18next';
// import './customers.scss'

// const KycStatusIcon = ({ status,expireDate }) => {  // ← props object, not plain argument
//   const { t } = useTranslation();

//   switch (status) {
//     case "In Progress":
//       return (
//         <div className="kycTooltip-area-up" style={{ width: "auto", height: "auto" }}>
//           <KycInProgress />
//           <span className="kycTooltip-area-up-text">In Progress</span>
//         </div>
//       );
//     case "Rejected":
//       return (
//         <div className="kycTooltip-area-up" style={{ width: "auto", height: "auto" }}>
//           <KycRejected />
//           <span className="kycTooltip-area-up-text">Rejected</span>
//         </div>
//       );
//     case "Expired":
//       return (
//         <div className="kycTooltip-area-up" style={{ width: "auto", height: "auto" }}>
//           <KycExpired />
//           <span className="kycTooltip-area-up-text">Expired</span>
//         </div>
//       );
//     case "Approved":
//       return (
//         <div className="kycTooltip-area-up" style={{ width: "auto", height: "auto" }}>
//           <KycApproved />
//           <span className="kycTooltip-area-up-text">Approved</span>
//         </div>
//       );
//     case "Completed":
//       return (
//         <div className="kycTooltip-area-up" style={{ width: "auto", height: "auto" }}>
//           <KycCompleted />
//           <span className="kycTooltip-area-up-text">Completed</span>
//         </div>
//       );
//  default:
//   return (
//     <div>
//       <span className="kyc-btn">
//         {t("Verify KYC")}
//       </span>
//     </div>
//   );
//   }
// };

// export default KycStatusIcon;

import React from "react";
import KycInProgress from "admin/common/icons/kycInProgress";
import KycRejected from "admin/common/icons/kycRejected";
import KycExpired from "admin/common/icons/kycExpired";
import KycApproved from "admin/common/icons/kycApproved";
import KycCompleted from "admin/common/icons/kycCompleted";
import { useTranslation } from "react-i18next";
import "./customers.scss";

const KycStatusIcon = ({ status, expireDate }) => {
  const { t } = useTranslation();

  const isExpired =
    expireDate && new Date(expireDate) < new Date(new Date().toDateString());

  if (isExpired && (status === "Approved" || status === "Completed")) {
    return (
      <div>
        <span className="kyc-btn">{t("Expired")}</span>
      </div>
    );
  }

  switch (status) {
    case "In Progress":
      return (
        <div
          className="kycTooltip-area-up"
          style={{ width: "auto", height: "auto" }}
        >
          <KycInProgress />
          <span className="kycTooltip-area-up-text">In Progress</span>
        </div>
      );
    case "Rejected":
      return (
        <div
          className="kycTooltip-area-up"
          style={{ width: "auto", height: "auto" }}
        >
          <KycRejected />
          <span className="kycTooltip-area-up-text">Rejected</span>
        </div>
      );
    case "Expired":
      return (
        <div
          className="kycTooltip-area-up"
          style={{ width: "auto", height: "auto" }}
        >
          <KycExpired />
          <span className="kycTooltip-area-up-text">Expired</span>
        </div>
      );
    case "Approved":
      return (
        <div
          className="kycTooltip-area-up"
          style={{ width: "auto", height: "auto" }}
        >
          <KycApproved />
          <span className="kycTooltip-area-up-text">Approved</span>
        </div>
      );
    case "Completed":
      return (
        <div
          className="kycTooltip-area-up"
          style={{ width: "auto", height: "auto" }}
        >
          <KycCompleted />
          <span className="kycTooltip-area-up-text">Completed</span>
        </div>
      );
    default:
      return (
        <div>
          <span className="kyc-btn">{t("Verify")}</span>
        </div>
      );
  }
};

export default KycStatusIcon;
